import React, { createContext, useState, ReactNode } from "react";
import SubscriptionApi from "../api/subscription/SubscriptionApi";

interface SubscriptionContextValue {
  subscriptionApi: SubscriptionApi;
}

export const SubscriptionContext = createContext<SubscriptionContextValue | null>(null);

interface SubscriptionProviderProps {
  children: ReactNode;
}

export const SubscriptionProvider = ({ children }: SubscriptionProviderProps) => {
  const [subscriptionApi] = useState(() => new SubscriptionApi());

  const value = React.useMemo(() => ({ subscriptionApi }), [subscriptionApi]);

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
}